style= require('./edit-matches.styl')
- var moment = require('moment')

sporty-seasons(
  season=season,
  (change:season)=this.changeSeason(e)
)

.matches
  .match
    .uid UID
    .round GW
    .start Start Time
    .home Home
    .away Away
  each match, $index in realMatches
    .match(data-match=match._id class={odd: $index % 2, saved: match.$justSaved})
      .uid= match.uid
      .round
        input(
          name="round",
          tabindex=1,
          type="number",
          step="1",
          value=match.round,
          (blur)=this.saveRound(match, e))
      .start
        input(
          name="start-date",
          tabindex=2,
          type="date",
          value=moment(match.startTime).format('YYYY-MM-DD'),
          (blur)=this.saveDate(match, e))
        input(
          name="start-time",
          tabindex=2,
          type="time",
          value=moment(match.startTime).format('HH:mm'),
          (blur)=this.saveTime(match, e))
      .home= match.homeTeam.name
      .away= match.awayTeam.name

